import type { AfterShipAdsLoggerLike } from './types';

/**
 * Every log this package emits is a `client` log namespaced under `AfterShipAds`; only the
 * calling function and the message differ. These wrappers keep that boilerplate in one
 * place so call sites read as one line.
 */
const buildParams = (context: string, message: string) => ({
  type: 'client' as const,
  context: `AfterShipAds - ${context}`,
  message,
});

export const logInfo = (logger: AfterShipAdsLoggerLike, context: string, message: string): void => {
  logger.info(buildParams(context, message));
};

export const logError = (
  logger: AfterShipAdsLoggerLike,
  context: string,
  message: string,
  error?: unknown,
): void => {
  logger.error(buildParams(context, message), error ? { error } : undefined);
};
